import Enums from '@core/types/api/Enums';
import { hasValue } from '@core/utils/equality';
import type { NotificationCardItem } from '@core/utils/notificationCard';

const RECORD_TYPE_ROUTE_PREFIX: Record<Enums.ReminderUserSettingsRecordType, string> = {
  [Enums.ReminderUserSettingsRecordType.Project]: '/projects',
  [Enums.ReminderUserSettingsRecordType.Quote]: '/quotes',
  [Enums.ReminderUserSettingsRecordType.Activity]: '/activities',
};

export const recordLinkHref = (record: NotificationCardItem['record']): string | undefined => {
  if (!hasValue(record)) {
    return undefined;
  }

  return `${RECORD_TYPE_ROUTE_PREFIX[record.type]}/${record.id}`;
};
